<template>
  <div class="pay-image">
    <UploadImage
      :maxNumber="3"
      ref="uploadImageRef"
      @on-change="onChange"
    ></UploadImage>
    <p style="color: red">
      提示：①费用支出上传付款证明函；②税金支出上传报税证明；③工资支出上传工资发放证明
    </p>
  </div>
</template>

<script>
import UploadImage from '@c/Base/UploadImage.vue'
export default {
  components: {
    UploadImage
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {
    // setTimeout(() => {
    // this.$refs.uploadImageRef.setIds(this.ids)
    // }, 1500)
  },
  methods: {
    clear(){
      this.$refs.uploadImageRef.handleClear();
    },
    async getFileId() {
      let ids = await this.$refs.uploadImageRef.getResult()
      return ids
    },
    onChange(val) {
      console.log(val, val.length);
      // 为了form表单校验 占位
      this.$emit('on-change', val.length > 0 ? [1] : [])
    }
  }
}
</script>

<style lang="scss" scoped>
</style>